import { render, staticRenderFns } from "./SlrcPD.vue?vue&type=template&id=a52b2b86"
import script from "./SlrcPD.vue?vue&type=script&lang=js"
export * from "./SlrcPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports